import { Icon, IconColor, IconID } from '@hub/common/Icon/Icon';
import classNames from 'classnames';
import { useTranslation } from 'next-i18next';

type AboutThermalPropertiesProps = {
  setShowAboutThermalProperties: (value: boolean) => void;
};

type ThermalPropertiesInformation = {
  title: string;
  description: string;
};

export const AboutThermalProperties = ({ setShowAboutThermalProperties }: AboutThermalPropertiesProps) => {
  const { t } = useTranslation(['category/productFilter', 'common']);

  const thermalPropertiesInformations: ThermalPropertiesInformation[] = [
    {
      title: t(`MATERIALS-INFO.LOWER_APPLICATION_TEMPERATURE`, { ns: 'free-form-hub/materials' }),
      description: t('ABOUT-THERMAL-PROPERTIES.MIN_TEMPERATURE', { ns: 'free-form-hub/materials' }),
    },
    {
      title: t(`MATERIALS-INFO.UPPER_APPLICATION_TEMPERATURE`, { ns: 'free-form-hub/materials' }),
      description: t('ABOUT-THERMAL-PROPERTIES.MAX_TEMPERATURE_LONG', { ns: 'free-form-hub/materials' }),
    },
    {
      title: t(`MATERIALS-INFO.MAX_TEMPERATURE_SHORT`, { ns: 'free-form-hub/materials' }),
      description: t('ABOUT-THERMAL-PROPERTIES.MAX_TEMPERATURE_SHORT', { ns: 'free-form-hub/materials' }),
    },
  ];

  const about = (info: ThermalPropertiesInformation) => (
    <div className="px-60 mt-8">
      <span className="text-[20px]">{info.title}</span>
      <p className="text-sm mt-4">{info.description}</p>
    </div>
  );
  return (
    <div className="w-[calc(100vw-16px)] h-[100vh] overflow-auto">
      <div>
        <div className="flex justify-between px-60 pt-24">
          <div>
            <span className="text-4xl font-semibold">
              {t('ABOUT-THERMAL-PROPERTIES.TITLE', { ns: 'free-form-hub/materials' })}
            </span>
          </div>
          <button
            onClick={() => {
              setShowAboutThermalProperties(false);
            }}
            type="button"
            data-testid="dialog-close-icon"
            className={classNames('w-16 h-16')}
          >
            <Icon size={10} color={IconColor.BLACK} id={IconID.CLOSE_CROSS} />
          </button>
        </div>
      </div>
      {thermalPropertiesInformations.map(info => about(info))}
    </div>
  );
};
